import { render, staticRenderFns } from "./cncdPuple.vue?vue&type=template&id=8fdcc566&scoped=true"
import script from "./cncdPuple.vue?vue&type=script&lang=js"
export * from "./cncdPuple.vue?vue&type=script&lang=js"
import style0 from "./cncdPuple.vue?vue&type=style&index=0&id=8fdcc566&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdcc566",
  null
  
)

export default component.exports